import "./Subsection.scss";
import React, { useEffect, useState } from "react";
import {
  Row
} from "antd";
import { Paragraph, FieldSet, Table, Text, Decision } from '..'

import { useTranslation } from "react-i18next";

const Subsection = ({ formId, client, record, section, component, subsection, mode, lang, showErrors, handleChangeValues }) => {
  const { t } = useTranslation()

  return (
    <div className={'form-manager-subsection-content mode-'+mode}>
        { component.type === 'SUBSECTION' &&
          <h4 className="section-title">{subsection.title && subsection.title[lang]}</h4>
        }
        { subsection.components && subsection.components.length > 0 &&
          <div className="section-body">
          { subsection.components && subsection.components.map((component, index) =>
              ((component.type === 'PARAGRAPH' && component.text) || component.type !== 'PARAGRAPH') &&
                <Row className={'section-component section-component-type-'+component.type}>
                    { component.type === 'PARAGRAPH' &&
                        <Paragraph component={component} record={record} mode={mode} lang={lang} handleChangeValues={handleChangeValues} />
                    }
                    { component.type === 'FIELDSET' &&
                        <FieldSet formId={formId} client={client} record={record} section={section} parent={section} component={component} mode={mode} lang={lang}
                          showErrors={showErrors}
                          handleChangeValues={handleChangeValues} 
                        />
                    }
                    { (component.type === 'TABLE' || component.type === 'DECL') &&
                        <Table formId={formId} client={client} record={record} section={section} component={component} mode={mode} lang={lang} handleChangeValues={handleChangeValues} showErrors={showErrors} />
                    }
                    { component.type === 'TEXT' &&
                        <Text component={component} mode={mode} lang={lang} handleChangeValues={handleChangeValues} />
                    }
                    { component.type === 'DECISION' &&
                      <Decision formId={formId} client={client} record={record} section={section} component={component} mode={mode} lang={lang} showErrors={showErrors} handleChangeValues={handleChangeValues} />
                    }
                </Row>
          )}
          </div>
        }
    </div>
  )
}

export default Subsection;
